<template>
  <ContentSection
    skew="none"
    class="bg-white max-w-5xl mx-auto pb-16 pt-5 block"
    style="background: transparent !important;"
  >
    <div class="text-2xl md:text-4xl font-normal leading-normal pt-0">
      At Pipefish, we help our customers across public and private sectors to transform, modernise
      and humanise their enterprise technology services and platforms.
    </div>
  </ContentSection>
</template>

<script>
import '@/components/svg/services';
import ContentSection from '@/components/ContentSection.vue';
export default {
  name: 'HomeHero',
  components: { ContentSection }
};
</script>

<style lang="scss"></style>
